import { render, staticRenderFns } from "./FollowForm.vue?vue&type=template&id=c1732f46&scoped=true"
import script from "./FollowForm.vue?vue&type=script&lang=js"
export * from "./FollowForm.vue?vue&type=script&lang=js"
import style0 from "./FollowForm.vue?vue&type=style&index=0&id=c1732f46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1732f46",
  null
  
)

export default component.exports